import { Link } from 'react-router-dom';
import { Link as commonUiLink } from '@experian-uk/corvetteuk-common-ui';

export default commonUiLink.Anchor.withComponent(Link);
